import { Controller } from '@hotwired/stimulus'

// Handles responsive behavior for the feature comparison table
// - Shows scroll indicators on mobile when table overflows
// - Provides horizontal scroll navigation
export default class extends Controller {
  static targets = ['table', 'scrollLeft', 'scrollRight']

  connect() {
    this.checkOverflow()
    this.updateScrollIndicators()

    // Re-check on resize
    this.resizeObserver = new ResizeObserver(() => {
      this.checkOverflow()
      this.updateScrollIndicators()
    })

    if (this.hasTableTarget) {
      this.resizeObserver.observe(this.tableTarget)
      this.tableTarget.addEventListener('scroll', () => this.updateScrollIndicators())
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  checkOverflow() {
    if (!this.hasTableTarget) return

    const isOverflowing = this.tableTarget.scrollWidth > this.tableTarget.clientWidth

    if (this.hasScrollLeftTarget) {
      this.scrollLeftTarget.classList.toggle('hidden', !isOverflowing)
    }
    if (this.hasScrollRightTarget) {
      this.scrollRightTarget.classList.toggle('hidden', !isOverflowing)
    }
  }

  updateScrollIndicators() {
    if (!this.hasTableTarget) return

    const { scrollLeft, scrollWidth, clientWidth } = this.tableTarget
    const maxScroll = scrollWidth - clientWidth

    // Hide left indicator at start
    if (this.hasScrollLeftTarget) {
      this.scrollLeftTarget.classList.toggle('opacity-0', scrollLeft <= 10)
    }

    // Hide right indicator at end
    if (this.hasScrollRightTarget) {
      this.scrollRightTarget.classList.toggle('opacity-0', scrollLeft >= maxScroll - 10)
    }
  }

  scrollLeft() {
    if (!this.hasTableTarget) return
    this.tableTarget.scrollBy({ left: -200, behavior: 'smooth' })
  }

  scrollRight() {
    if (!this.hasTableTarget) return
    this.tableTarget.scrollBy({ left: 200, behavior: 'smooth' })
  }
}
